/**
 * @purpose: controller untuk BAGGING AUDIT LOG - tracking perubahan data bagging
 * @called_by: bagging_audit.html
 * @deps: bagging_pg_controller.js listBaggingAudit
 * @public: baggingAuditCtrl
 * @side_effects: memanggil /api/bagging-audit
 */
app.controller('baggingAuditCtrl', function ($scope, $filter, urlServices, toaster, _VAR_GLOBAL) {
    $scope.loading = false;
    $scope.filter = {
        dateRange: {
            startDate: moment().startOf('day'),
            endDate: moment().add(30, 'days')
        },
        action: '',
        pageSize: _VAR_GLOBAL.limit || 50,
        term: ''
    };
    $scope.pagination = {
        pageNumber: 1
    };
    $scope.dataList = {
        records: 0,
        data: []
    };

    function buildQuery(page) {
        var p = page || 1;
        var startDate = $filter('date')($scope.filter.dateRange.startDate._d || $scope.filter.dateRange.startDate, 'yyyy-MM-dd');
        var endDate = $filter('date')($scope.filter.dateRange.endDate._d || $scope.filter.dateRange.endDate, 'yyyy-MM-dd');
        var query = [
            'pg=' + p,
            'limit=' + $scope.filter.pageSize,
            'startDate=' + encodeURIComponent(startDate),
            'endDate=' + encodeURIComponent(endDate)
        ];
        if ($scope.filter.action) {
            query.push('action=' + encodeURIComponent($scope.filter.action));
        }
        if ($scope.filter.term) {
            query.push('term=' + encodeURIComponent($scope.filter.term));
        }
        return query.join('&');
    }

    $scope.loadData = function (page) {
        $scope.loading = true;
        var query = buildQuery(page);
        return urlServices.ambilData('api/bagging-audit?' + query, {}, function (err, result) {
            $scope.loading = false;
            if (err) {
                $scope.dataList.records = 0;
                $scope.dataList.data = [];
                return toaster.pop('error', 'Bagging Audit', 'Gagal memuat data: ' + (err.err || err.message || err));
            }
            $scope.dataList.records = result && result.records ? result.records : 0;
            $scope.dataList.data = result && result.data ? result.data : [];
        });
    };

    // Initial load
    $scope.loadData(1);
});